import ApiRoutes from "api/apiRoutes";
import { exeRequest } from "http/requestConfig";

export default class EngagementService {

    static getAll(options, sCallBack, eCallBack) {
        ApiRoutes.engagementsResource.resourceOptions = Object.assign({}, ApiRoutes.engagementsResource.resourceOptions, options);
        exeRequest(ApiRoutes.engagementsResource, {}, sCallBack, eCallBack)
    }
}